import { render } from "./mainMenuBar.vue?vue&type=template&id=5590f9d2&scoped=true&ts=true"
import script from "./mainMenuBar.vue?vue&type=script&lang=ts"
export * from "./mainMenuBar.vue?vue&type=script&lang=ts"

import "./mainMenuBar.vue?vue&type=style&index=0&id=5590f9d2&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5590f9d2"]])

export default __exports__